import { SlidersHorizontal } from "lucide-react";
import { useEffect, useState } from "react";

import FiltersSelects from "./FiltersSelects";

function FiltersForm() {
  const [addSticky, setAddSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      setAddSticky(scrollTop > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className={addSticky ? "sticky-bar sticky-bar-fixed" : "sticky-bar"}>
      <div className="uk-flex uk-flex-middle">
        <div className="all-filters-toggle">
          <button
            className="uk-button uk-button-primary uk-button-small"
            type="button"
          >
            <SlidersHorizontal /> Tutti i Filtri
          </button>
        </div>
        <div className="filters">
          <FiltersSelects />
        </div>
      </div>
    </div>
  );
}

export default FiltersForm;
